/**
 * Default Property Schemas
 * Phase 1: Foundation & Type Safety
 * 
 * Example property schemas for common node types
 * 
 * NOTE: This file contains example schemas using the old property system.
 * Individual nodes should use their own schema files in shared/nodes/[category]/[node-name]/schema.ts
 * which follow the correct NodePropertySchema structure from node-properties.ts
 */

import { NodePropertySchema } from '../types/node-properties';

/**
 * All default schemas
 * 
 * NOTE: These are placeholder examples. Real node schemas are defined in their respective node folders.
 */
export const defaultPropertySchemas: NodePropertySchema[] = [];
